import {
  Button,
  FormField,
  Heading,
  Input,
  VisualSizesEnum,
} from '@frontapp/ui-kit';
import type React from 'react';
import { useState } from 'react';

type Props = {
  onToken: (token: string) => void;
};

function Login({ onToken }: Props) {
  const [token, setToken] = useState('');

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    onToken(token);
  }

  return (
    <div className="Login">
      <Heading size={VisualSizesEnum.EXTRA_LARGE}>
        That time of the month has arrived! 📅😉
      </Heading>
      <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
        <FormField
          hint="Look for the CUSTOMER_INSPECT_TOKEN_LVL2 key on Bitwarden"
          label="Please enter customer token:"
        >
          <Input
            name="info"
            type="text"
            shouldFocus={true}
            iconName="Archive"
            placeholder="Please set the new token :)"
            value={token}
            onChange={(value) => setToken(value)}
          />
        </FormField>
        <div style={{ marginTop: '20px' }}>
          <Button type="primary">Save token</Button>
        </div>
      </form>
    </div>
  );
}

export default Login;
